import { render, staticRenderFns } from "./7Utos.vue?vue&type=template&id=2d3f135e&scoped=true&"
import script from "./7Utos.vue?vue&type=script&lang=js&"
export * from "./7Utos.vue?vue&type=script&lang=js&"
import style0 from "./7Utos.vue?vue&type=style&index=0&id=2d3f135e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_babel-core@6.26.3_css-loader@6.7.3_lodash@4.17.21_vue-template-compiler@2.7.14_webpack@5.81.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f135e",
  null
  
)

export default component.exports